import config from 'src/config/config';
import api from 'src/api/interceptor';

export function getPaginatedProductsApi(tenantId, searchTerm) {
  return api
    .get(`${config.test_url}api/material/get-paginated-products/`, {
      params: {
        tenant_id: tenantId,
        search_term: searchTerm,
      },
    })
    .then((res) => Promise.resolve(res));
}

export function getProductOptionsApi(
  tenantOrganisationId,
  searchTerm,
  pageNumber = 1,
  paginationBatchSize = 10,
) {
  return api
    .get(`${config.test_url}api/material/get-product-options/`, {
      params: {
        tenant_organisation_id: tenantOrganisationId,
        search_term: searchTerm,
        page_number: pageNumber,
        pagination_batch_size: paginationBatchSize,
      },
    })
    .then((res) => Promise.resolve(res));
}

export function createPackTypeAssignmentApi(data) {
  return api
    .post(
      `${config.test_url}api/vehicle-tracking/create-pack-type-assignment/`,
      data,
    )
    .then((res) => Promise.resolve(res));
}

export function getProductPackTypeAssignmentsApi(
  tenantOrganisationId,
  pageNumber,
  queryString,
) {
  const searchFieldFilterList = new URLSearchParams(queryString).toString();
  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-product-pack-type-assignments/?${searchFieldFilterList}`,
      {
        params: {
          tenant_organisation_id: tenantOrganisationId,
          page_number: pageNumber,
        },
      },
    )
    .then((res) => Promise.resolve(res));
}

export function getProfileDetailsApi(tenantId, profileId) {
  return api
    .get(
      `${config.test_url}api/core/get-profile-details/?tenant_id=${tenantId}&profile_id=${profileId}`,
    )
    .then((res) => Promise.resolve(res));
}

export function getTransporterListApi(
  tenantOrganisationId,
  pageNumber,
  searchInput,
  tableFieldFilter,
  paginationBatchSize,
  queryString,
) {
  const params = new URLSearchParams(queryString);

  tableFieldFilter?.forEach((fieldId) => params.append('field_id', fieldId));

  return api
    .get(
      `${config.test_url}api/vehicle-tracking/get-transporter-list/?${params.toString()}`,
      {
        params: {
          tenant_organisation_id: tenantOrganisationId,
          page_number: pageNumber,
          search_term: searchInput || null,
          pagination_batch_size: paginationBatchSize,
        },
      },
    )
    .then((res) => Promise.resolve(res));
}
